/* eslint-disable prettier/prettier */
export const formatSize = (bytes: string | number): string => {
  const size = typeof bytes === 'string' ? parseInt(bytes, 10) : bytes;
  return (size / (1024 * 1024)).toFixed(2) + ' MB';
};
